var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 693.81 462.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#606060;}.cls-2{fill:#ebebeb;}.cls-3{fill:#f5f5f5;}.cls-4{opacity:0.3;}.cls-5{fill:#fafafa;}.cls-6{fill:#fff;}.cls-7{fill:#263238;}.cls-8{fill:#ffbe9d;}.cls-9{fill:#eb996e;}.cls-10{fill:#0092bc;}.cls-11{fill:#a5695f;}.cls-12{fill:#83534b;}.cls-13{fill:none;stroke:#4f595e;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.38,293.48a35.32,35.32,0,0,1-.26-6,35.32,35.32,0,0,1,.26-6,33.5,33.5,0,0,1,.27,6A33.5,33.5,0,0,1,94.38,293.48Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.38,317.48a69.36,69.36,0,0,1,0-12,66.8,66.8,0,0,1,0,12Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.38,341.48a69.36,69.36,0,0,1,0-12,66.8,66.8,0,0,1,0,12Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.38,365.48a69.36,69.36,0,0,1,0-12,66.8,66.8,0,0,1,0,12Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.38,389.48a69.36,69.36,0,0,1,0-12,66.8,66.8,0,0,1,0,12Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104,403.82a34.12,34.12,0,0,1-6,.26c-1.38,0-2.66,0-3.66-.05h0a.2.2,0,0,1-.19-.21,9.66,9.66,0,0,1,.2-2.34,8.76,8.76,0,0,1,.21,2.34l-.21-.2c1,0,2.28-.06,3.66-.06A35.32,35.32,0,0,1,104,403.82Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,403.82a34.12,34.12,0,0,1-6,.26,34.12,34.12,0,0,1-6-.26,35.32,35.32,0,0,1,6-.26A35.32,35.32,0,0,1,128,403.82Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152,403.82a34.12,34.12,0,0,1-6,.26,34.12,34.12,0,0,1-6-.26,35.32,35.32,0,0,1,6-.26A35.32,35.32,0,0,1,152,403.82Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.45,403.82a13.12,13.12,0,0,1-3.7.26,13.17,13.17,0,0,1-3.71-.26,13.62,13.62,0,0,1,3.71-.26A13.58,13.58,0,0,1,171.45,403.82Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.11,59.84a17.44,17.44,0,0,1,6,0,17.44,17.44,0,0,1-6,0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.42,59.84a51.53,51.53,0,0,1,10.34,0,51.53,51.53,0,0,1-10.34,0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.72,59.84a51.63,51.63,0,0,1,10.35,0,51.63,51.63,0,0,1-10.35,0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.38,65.84a34.12,34.12,0,0,1-.26-6l.26-.26h2.33l1.91.06a5.9,5.9,0,0,1,1.76.18,6.07,6.07,0,0,1-1.76.19l-1.91,0-1.12,0h-1.21c.12-.11-.26.26.26-.26A35.32,35.32,0,0,1,275.38,65.84Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.38,89.1a32,32,0,0,1-.26-5.81,32,32,0,0,1,.26-5.82,33.16,33.16,0,0,1,.26,5.82A33.09,33.09,0,0,1,275.38,89.1Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.38,106.73a8.68,8.68,0,0,1-.26-3,8.68,8.68,0,0,1,.26-3,9,9,0,0,1,.26,3A9,9,0,0,1,275.38,106.73Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M579.8,146.76a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.8,146.76a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M627.8,146.76a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651.8,146.76a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.8,146.76a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.33,147.22s-.07-.16-.1-.46l.1.1c-.9.09-3,.16-5.53.16a35.22,35.22,0,0,1-6-.26,35.22,35.22,0,0,1,6-.26c2.49,0,4.63.06,5.53.16h0a.09.09,0,0,1,.08.1C699.4,147.06,699.37,147.22,699.33,147.22Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.33,171.22a35.22,35.22,0,0,1-.26-6,35.32,35.32,0,0,1,.26-6,34.12,34.12,0,0,1,.26,6A34,34,0,0,1,699.33,171.22Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.33,195.22a35.22,35.22,0,0,1-.26-6,35.32,35.32,0,0,1,.26-6,34.12,34.12,0,0,1,.26,6A34,34,0,0,1,699.33,195.22Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.33,219.22a35.22,35.22,0,0,1-.26-6,35.32,35.32,0,0,1,.26-6,34.12,34.12,0,0,1,.26,6A34,34,0,0,1,699.33,219.22Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.33,243.22a35.22,35.22,0,0,1-.26-6,35.32,35.32,0,0,1,.26-6,34.12,34.12,0,0,1,.26,6A34,34,0,0,1,699.33,243.22Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.33,267.22a35.22,35.22,0,0,1-.26-6,35.32,35.32,0,0,1,.26-6,34.12,34.12,0,0,1,.26,6A34,34,0,0,1,699.33,267.22Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M687.86,279.75a34,34,0,0,1,6-.26c2.44,0,4.55.06,5.47.15l-.1.11c0-.34.06-.53.1-.53s.07.19.11.53a.1.1,0,0,1-.09.1h0c-.92.1-3,.16-5.47.16A35.22,35.22,0,0,1,687.86,279.75Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M663.86,279.75a69.36,69.36,0,0,1,12,0,69.36,69.36,0,0,1-12,0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M638.57,120.56,641,160a2.67,2.67,0,0,0,2.66,2.5h71a2.68,2.68,0,0,0,2.67-2.67v-30.7a2.68,2.68,0,0,0-2.68-2.67l-43.66.29a2.74,2.74,0,0,1-1.89-.77l-7.58-7.47a2.68,2.68,0,0,0-1.87-.77H641.22A2.66,2.66,0,0,0,638.57,120.56Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 611.25,
    y: 97.84,
    width: 77.56,
    height: 46.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M633.58,126l5.92,48.33a1.71,1.71,0,0,0,1.7,1.51h75.58a1.71,1.71,0,0,0,1.71-1.58l3.81-48.33a1.71,1.71,0,0,0-1.71-1.85H635.28A1.71,1.71,0,0,0,633.58,126Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.77,87.37A18.61,18.61,0,0,0,90.86,70.15c0-10.29-7.74-18.66-17.39-18.71S56,59.7,55.94,70A18.58,18.58,0,0,0,67.06,87.37c-26.87,4-25.65,33.25-25.65,33.25l63.54.3S106.4,91.39,79.77,87.37Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M608.4,63.15a13.81,13.81,0,0,0,8.24-12.78c0-7.64-5.75-13.85-12.91-13.89s-13,6.13-13,13.77A13.77,13.77,0,0,0,599,63.15c-20,3-19.05,24.69-19.05,24.69l47.17.22S628.18,66.14,608.4,63.15Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.77,55.72A8.79,8.79,0,0,0,177,47.59a8.26,8.26,0,1,0-16.48-.08,8.8,8.8,0,0,0,5.25,8.21c-12.68,1.91-12.1,15.69-12.1,15.69l30,.13S184.34,57.61,171.77,55.72Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M431.87,439.38a11.33,11.33,0,0,0,6.75-10.48c0-6.26-4.71-11.36-10.58-11.39s-10.65,5-10.67,11.29a11.33,11.33,0,0,0,6.77,10.58c-16.35,2.46-15.61,20.24-15.61,20.24l38.67.18S448.08,441.83,431.87,439.38Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 584.78,
    y: 344.23,
    width: 93.81,
    height: 90.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "592.05 427.23 618 380.52 639.23 410.38 652.13 394.52 671.32 427.23 592.05 427.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M676.77,395.4a6.76,6.76,0,1,1-6.76-6.75A6.76,6.76,0,0,1,676.77,395.4Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.81,451.44a2.89,2.89,0,0,1,0-.37c0-.27,0-.62,0-1.06,0-1,0-2.33,0-4.08,0-3.6-.05-8.81-.1-15.42,0-13.26-.11-32.13-.19-54.8l.38.38-79.26.07c-.1.09.84-.85.44-.44V396.1c0,6.67,0,13.2,0,19.55,0,12.72,0,24.73-.05,35.79l-.39-.39,57.32.2,16.16.1,4.29,0,1.11,0,.39,0a2.06,2.06,0,0,1-.35,0l-1.06,0-4.22,0-16.07.1-57.57.2h-.38v-.39c0-11.06,0-23.07,0-35.79,0-6.35,0-12.88,0-19.55V375.72c-.4.39.54-.56.45-.46l79.26.06h.39v.38c-.08,22.77-.14,41.73-.19,55,0,6.58-.08,11.75-.1,15.33,0,1.73,0,3.07,0,4,0,.43,0,.76,0,1A1.06,1.06,0,0,1,699.81,451.44Z",
    transform: "translate(-28.49 -23.96)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 279.41,
    width: 39.92,
    height: 38.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.1 314.72 14.14 294.85 23.17 307.55 28.66 300.81 36.83 314.72 3.1 314.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.51,314.94a2.87,2.87,0,1,1-2.87-2.87A2.86,2.86,0,0,1,55.51,314.94Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.32,338.79a1.08,1.08,0,0,1,0-.16c0-.11,0-.26,0-.45,0-.41,0-1,0-1.74,0-1.53,0-3.74,0-6.56,0-5.64,0-13.67-.08-23.32l.16.17-33.73,0,.19-.18h0v8.65c0,2.84,0,5.62,0,8.32,0,5.41,0,10.52,0,15.23l-.16-.17,24.39.09,6.88,0,1.82,0h0l-1.8,0-6.84,0L31.59,339h-.17v-.17c0-4.71,0-9.82,0-15.23,0-2.7,0-5.48,0-8.32v-8.65h0l.19-.2,33.73,0h.16v.16c0,9.69-.06,17.76-.08,23.43,0,2.79,0,5,0,6.52,0,.73,0,1.3,0,1.71,0,.18,0,.32,0,.43A.66.66,0,0,1,65.32,338.79Z",
    transform: "translate(-28.49 -23.96)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.46,374l2.25,36.44a2.45,2.45,0,0,0,2.45,2.31h65.6a2.47,2.47,0,0,0,2.47-2.46V381.93a2.47,2.47,0,0,0-2.48-2.46l-40.34.26a2.48,2.48,0,0,1-1.75-.71l-7-6.9a2.44,2.44,0,0,0-1.73-.71h-17A2.46,2.46,0,0,0,48.46,374Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 21.06,
    y: 351.2,
    width: 71.68,
    height: 42.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.85,379l5.47,44.66a1.59,1.59,0,0,0,1.57,1.39h69.85a1.57,1.57,0,0,0,1.58-1.46l3.52-44.66a1.59,1.59,0,0,0-1.58-1.71H45.42A1.58,1.58,0,0,0,43.85,379Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.88,251.63a9.7,9.7,0,0,1-.22-2,17.36,17.36,0,0,0-.26-2.36,24.91,24.91,0,0,0-.62-3.16,29.73,29.73,0,0,0-3.29-8.16,30.59,30.59,0,0,0-7.58-8.73,30.22,30.22,0,0,0-28.47-4.89,28.19,28.19,0,0,0-7.7,3.93,33.25,33.25,0,0,0-3.48,2.82,34.11,34.11,0,0,0-3,3.42,30,30,0,0,0-.86,35.52,34,34,0,0,0,2.86,3.56,33.42,33.42,0,0,0,3.33,3,28.5,28.5,0,0,0,7.5,4.3,30.33,30.33,0,0,0,15.79,1.75,30,30,0,0,0,12.89-5.26,30.54,30.54,0,0,0,8-8.35,29.94,29.94,0,0,0,3.68-8,23.18,23.18,0,0,0,.77-3.13,16.22,16.22,0,0,0,.38-2.34,9.74,9.74,0,0,1,.31-2,8.32,8.32,0,0,1,0,2,14.36,14.36,0,0,1-.22,2.39,21.55,21.55,0,0,1-.64,3.23,29,29,0,0,1-3.51,8.31A31.28,31.28,0,0,1,365.08,282a31.56,31.56,0,0,1-16.59-1.69,29.91,29.91,0,0,1-7.93-4.47A29,29,0,0,1,334,269a31.47,31.47,0,0,1,.91-37.49,36.58,36.58,0,0,1,3.2-3.59,35.32,35.32,0,0,1,3.68-3,29.74,29.74,0,0,1,8.14-4.08,31.61,31.61,0,0,1,16.64-.89,31.37,31.37,0,0,1,20.74,15.53,29,29,0,0,1,3.1,8.47,21.25,21.25,0,0,1,.48,3.26,13.86,13.86,0,0,1,.1,2.4A8.45,8.45,0,0,1,390.88,251.63Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.71,232.33c.06.09-.49.58-1.57,1.38l-2,1.43c-.39.26-.8.57-1.26.86l-1.52.79a34.93,34.93,0,0,1-18.16,4.58l-2.75-.13-2.64-.41c-.43-.07-.86-.13-1.28-.21l-1.23-.33c-.81-.23-1.62-.42-2.38-.66a40.39,40.39,0,0,1-7.7-3.55c-4.14-2.51-6.16-4.78-6-4.93s2.42,1.72,6.59,3.88a46.18,46.18,0,0,0,7.58,3.1c.74.22,1.51.38,2.29.58l1.19.3,1.22.18,2.52.37,2.62.11a37.73,37.73,0,0,0,17.59-3.95l1.54-.67c.47-.24.89-.51,1.3-.73l2.11-1.16C384,232.53,384.64,232.23,384.71,232.33Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.29,269.88c-.07-.09.49-.57,1.56-1.38l2-1.42c.4-.27.81-.58,1.27-.86l1.52-.8a34.78,34.78,0,0,1,18.16-4.57l2.75.12,2.63.41c.43.08.87.13,1.29.22l1.23.33c.81.22,1.61.41,2.37.66a39.58,39.58,0,0,1,7.71,3.55c4.14,2.5,6.15,4.78,6,4.92s-2.41-1.71-6.58-3.88a46,46,0,0,0-7.59-3.1c-.74-.22-1.51-.38-2.29-.58l-1.18-.29-1.23-.19-2.52-.37-2.62-.1a37.54,37.54,0,0,0-17.58,3.94l-1.54.67c-.47.25-.9.51-1.31.74l-2.11,1.16C336,269.68,335.36,270,335.29,269.88Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.87,252.34c0,.47-13.85.52-30.9.1s-30.88-1.13-30.87-1.6,13.85-.51,30.91-.09S390.88,251.88,390.87,252.34Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.56,281.73c-.47,0-.51-13.84-.1-30.89s1.13-30.86,1.6-30.85.51,13.84.1,30.89S359,281.74,358.56,281.73Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.56,281.68c-.11.18-3.52-2.12-7.44-7.35a41.2,41.2,0,0,1-5.52-10,37.2,37.2,0,0,1-2.4-13.84,35.49,35.49,0,0,1,3.12-13.7,43.36,43.36,0,0,1,6-9.72c4.15-5,7.59-7.25,7.7-7.07s-2.94,2.72-6.76,7.81a46.57,46.57,0,0,0-5.54,9.6,35.59,35.59,0,0,0-2.86,13.11,37.67,37.67,0,0,0,2.16,13.27,44.87,44.87,0,0,0,5,9.87C355.67,278.9,358.73,281.5,358.56,281.68Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M360.75,220c.12-.18,3.52,2.12,7.45,7.35a41.54,41.54,0,0,1,5.52,10,37.41,37.41,0,0,1,2.39,13.84,35.49,35.49,0,0,1-3.12,13.7,42.68,42.68,0,0,1-6,9.71c-4.16,5-7.59,7.26-7.71,7.08s2.94-2.72,6.76-7.81a46.57,46.57,0,0,0,5.55-9.6,35.59,35.59,0,0,0,2.85-13.11,37.67,37.67,0,0,0-2.16-13.27,44.44,44.44,0,0,0-5-9.87C363.64,222.78,360.58,220.18,360.75,220Z",
    transform: "translate(-28.49 -23.96)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Character_4",
    "data-name": "Character 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 404.13,
    y: 219.7,
    width: 227.56,
    height: 169
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M660.18,412.67c0-1.77-.09-66.7-.22-169l.22.22-227.54,0h0l.26-.26c0,60.71,0,118.23,0,169l-.24-.24,227.56.24-227.56.23h-.23v-.23c0-50.78,0-108.3,0-169v-.26h.28l227.54,0h.21v.21C660.26,346,660.18,410.91,660.18,412.67Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.18,268.7c0,.15-50.83.27-113.53.27s-113.53-.12-113.53-.27,50.82-.26,113.53-.26S660.18,268.56,660.18,268.7Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.44,256.08a3.43,3.43,0,1,1-3.42-3.42A3.42,3.42,0,0,1,446.44,256.08Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.77,256.08a3.43,3.43,0,1,1-3.43-3.42A3.43,3.43,0,0,1,456.77,256.08Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.09,256.08a3.43,3.43,0,1,1-3.42-3.42A3.42,3.42,0,0,1,467.09,256.08Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555.38,231.06a6,6,0,0,0-6-3.33,8.14,8.14,0,0,0-10-.31,7.24,7.24,0,0,0-11.2,5.37,6,6,0,0,0-5.78,9.91,5.81,5.81,0,0,0,1.89,11.41L554,237.79A6,6,0,0,0,555.38,231.06Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M523.36,254.88A24.65,24.65,0,0,1,549,233.46l1.27.06c13.71,1.49,20.11,14,18.24,27.63l-4.26,45.69-.23,2.21-32,4.79.63-11.67s-13.12-2.71-12.63-15.94C520.25,279.85,521.81,266.73,523.36,254.88Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M532.53,302.15a32.17,32.17,0,0,0,17.57-4.21s-4.55,9.31-17.68,7.46Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M526.23,267.74a1.89,1.89,0,0,0,1.72,2,1.8,1.8,0,0,0,2-1.61,1.88,1.88,0,0,0-1.72-2A1.8,1.8,0,0,0,526.23,267.74Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M525.88,261.49c.22.26,1.71-.73,3.74-.62s3.47,1.19,3.7,1-.1-.56-.73-1.07a5.2,5.2,0,0,0-3-1.07,5,5,0,0,0-3,.8C526,260.94,525.77,261.38,525.88,261.49Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M544.15,269a1.9,1.9,0,0,0,1.73,2,1.82,1.82,0,0,0,2-1.61,1.89,1.89,0,0,0-1.72-2A1.82,1.82,0,0,0,544.15,269Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M545.83,262.86c.22.26,1.7-.73,3.73-.62s3.47,1.2,3.7,1-.1-.56-.72-1.07a5.26,5.26,0,0,0-2.95-1.07,5,5,0,0,0-3,.8C546,262.31,545.72,262.75,545.83,262.86Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M537.71,277.56a13.11,13.11,0,0,0-3.27-.76c-.52-.08-1-.21-1.07-.57a2.62,2.62,0,0,1,.42-1.52l1.73-3.87c2.41-5.52,4.18-10.06,4-10.16s-2.36,4.3-4.77,9.82c-.58,1.36-1.14,2.66-1.66,3.9a3,3,0,0,0-.37,2,1.29,1.29,0,0,0,.81.8,3.58,3.58,0,0,0,.87.17A13.75,13.75,0,0,0,537.71,277.56Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M543.62,279.26c-.33,0-.45,2.17-2.41,3.64s-4.3,1.11-4.33,1.42c0,.14.5.45,1.49.53a5.5,5.5,0,0,0,3.61-1.06,4.78,4.78,0,0,0,1.88-3.06C544,279.81,543.77,279.25,543.62,279.26Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.7,254.88c.17.56,2.21.4,4.58.8s4.26,1.15,4.61.68c.15-.23-.16-.77-.91-1.34a8.11,8.11,0,0,0-7-1.13C546.09,254.2,545.63,254.61,545.7,254.88Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.92,255.65c.34.48,1.76.07,3.44.13s3.09.47,3.45,0c.15-.23,0-.7-.65-1.17a4.78,4.78,0,0,0-2.76-.89,4.72,4.72,0,0,0-2.79.79C527,255,526.77,255.42,526.92,255.65Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M524.94,248.89s3.89-8.11,8-9.84c5-2.1,6.76,3.31,11.43,2.25s9.39-3.07,13.92.72c5,4.15,2.41,6.77,2.44,12.65.11,23.83,4.11,30.77,5.91,19.64.19-1.22,3.64-2,4.41-7.19,1-6.69,1.65-14.84.39-19.68-1.07-4.08-3.22-7-7.18-10.24C558,232,549.08,231.49,543,231.8S524.9,238.5,524.94,248.89Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M565.79,273.9a3.6,3.6,0,0,1,4.05-3.26c2.45.36,5.12,1.89,4.71,7-.74,9-9.65,6.42-9.64,6.16S565.45,277.68,565.79,273.9Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M567.15,280.54s.15.13.4.27a1.58,1.58,0,0,0,1.18.12c1-.27,1.9-1.72,2.08-3.34a5.19,5.19,0,0,0-.26-2.29,1.81,1.81,0,0,0-1.08-1.3.79.79,0,0,0-1,.36c-.14.24-.1.42-.15.43s-.18-.16-.08-.53a1,1,0,0,1,.4-.54,1.2,1.2,0,0,1,.89-.15,2.2,2.2,0,0,1,1.53,1.53,5.36,5.36,0,0,1,.34,2.56c-.21,1.81-1.28,3.44-2.61,3.71a1.73,1.73,0,0,1-1.42-.36C567.15,280.76,567.12,280.56,567.15,280.54Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566.48,256.39a8.6,8.6,0,0,1-3.91,1.58,3,3,0,0,1-3.17-2.24c-.07-.63.12-1.36-.27-1.86s-1.39-.47-2.15-.43A5.77,5.77,0,0,1,551.2,249c-.72,1-2.28.85-3.26.15a13.22,13.22,0,0,1-2.33-2.76,3.72,3.72,0,0,0-3-1.71,8.56,8.56,0,0,1-2,.34c-1.18-.16-1.69-1.58-1.81-2.77s-.2-2.57-1.17-3.26-2.13-.35-3.23-.25-2.49-.22-2.72-1.3a2.13,2.13,0,0,1,.49-1.62,5.86,5.86,0,0,1,7-1.87,7.94,7.94,0,0,1,14.65-.81,8.06,8.06,0,0,1,12.72,3.57,5.84,5.84,0,0,1,6.16,8.82,5.53,5.53,0,0,1,2.83,4.56c-.06,1.87-2,3.64-3.75,3.06a3.24,3.24,0,0,1-5.75,3",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M572.44,253.18a2.16,2.16,0,0,1-.65,1.7,2.88,2.88,0,0,1-1.86,1,3.13,3.13,0,0,1-2.54-.87l.38,0a8.91,8.91,0,0,1-1.91,2.16,5.18,5.18,0,0,1-1.7.94,3.48,3.48,0,0,1-1.83.08,3.52,3.52,0,0,1-2.53-1.62,5.26,5.26,0,0,1-.64-1.92,1.71,1.71,0,0,1,0-.73s.1.24.23.69a6.07,6.07,0,0,0,.75,1.76,3.69,3.69,0,0,0,5.42.4,9.13,9.13,0,0,0,1.83-2l.17-.26.21.22a2.74,2.74,0,0,0,2.15.8,2.63,2.63,0,0,0,1.67-.78A4.4,4.4,0,0,0,572.44,253.18Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M556.39,231.69s-.24.05-.65.2a3.17,3.17,0,0,0-1.46,1.13l-.12.16L554,233a11.22,11.22,0,0,0-4.19-3.76,8.82,8.82,0,0,0-3.52-.95,7.45,7.45,0,0,0-6.26,2.95,6.14,6.14,0,0,0-1.13,2.67l-.05.29-.27-.09a5,5,0,0,0-3.77.27,4.91,4.91,0,0,0-2.17,2.1,6.77,6.77,0,0,0-.69,2.65,1.81,1.81,0,0,1-.08-.75,5.31,5.31,0,0,1,.51-2,5.13,5.13,0,0,1,2.25-2.32,5.38,5.38,0,0,1,4.1-.37l-.31.2a6.56,6.56,0,0,1,1.2-2.92,7.88,7.88,0,0,1,6.7-3.15,9.08,9.08,0,0,1,3.7,1.06,10.93,10.93,0,0,1,4.22,4h-.23a3.08,3.08,0,0,1,1.65-1.1A1.36,1.36,0,0,1,556.39,231.69Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M546.66,280.73c-.15,0-.16-1-.89-1.79s-1.64-1-1.62-1.15.26-.13.66,0a2.63,2.63,0,0,1,1.36.86,2.59,2.59,0,0,1,.63,1.47C546.82,280.49,546.72,280.74,546.66,280.73Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M547.58,278.27c-.13.07-.44-.26-.91-.49s-.91-.33-.93-.47.55-.32,1.17,0S547.71,278.22,547.58,278.27Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M557.32,300s.14-.06.26-.23a.8.8,0,0,0,.06-.79c-.13-.35-.53-.67-.78-1.27a1.19,1.19,0,0,1,.06-1.05,7.74,7.74,0,0,1,.62-.75c.74-.86-1.28-1.57-1-2.71a1.46,1.46,0,0,1,.53-.95c.22-.14.36-.16.38-.13a1.79,1.79,0,0,0-.54,1.11,1.39,1.39,0,0,0,.62,1.09,2.26,2.26,0,0,1,.57.78,1.11,1.11,0,0,1-.17,1.13,9,9,0,0,0-.6.69.73.73,0,0,0-.05.63c.15.45.54.84.67,1.3a1,1,0,0,1-.26,1.07C557.49,300,557.31,300,557.32,300Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M560.14,299.65s0-.13-.1-.33a3.44,3.44,0,0,0-.47-.78,3.17,3.17,0,0,1-.36-.59,1.27,1.27,0,0,1-.09-.89c.18-.65.73-1,1-1.49s.07-.85-.3-1.26a2.71,2.71,0,0,1-.46-.68,1.67,1.67,0,0,1-.11-.74c.12-.94.77-1.19.77-1.13a2.44,2.44,0,0,0-.4,1.14,1.55,1.55,0,0,0,.56,1.1,2.27,2.27,0,0,1,.53.76,1.24,1.24,0,0,1-.14,1.08c-.38.59-.87.93-1,1.35a1.51,1.51,0,0,0,.3,1.16,2.32,2.32,0,0,1,.36.94C560.25,299.54,560.17,299.66,560.14,299.65Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M582.37,372.64l12,11.56-3.88-22.11,24.35-7.7s6.46,30.34,7.59,37.52c2,12.87-.46,31.18-12.46,32.47-13,1.39-22.79-11.41-29-19.82-4.79-6.46-12.53-17.75-12.53-17.75l14-14.17",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.62,353c-3.91,12.3-9.37,14.16-11.53,49.4-.42,6.87,1.07,16,7.58,18.26,7.25,2.46,18.33-2,21.8-8V388.4Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M505.76,404.44a55.59,55.59,0,0,0-2.4-5.17,51.26,51.26,0,0,0-3.31-4.65,4.88,4.88,0,0,1,1.26,1.13,18.35,18.35,0,0,1,2.42,3.3,18.65,18.65,0,0,1,1.67,3.74A5.35,5.35,0,0,1,505.76,404.44Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M483.74,367.16c.2-.73,12.22-33.44,16.05-40.6C504.38,318,514,314.21,520,313.84s70,4.73,70,4.73,17.94,4.51,21.57,20.74c4.55,20.36,8.21,40.43,8.21,40.43l-32.1,6.93-3.77-9.51-60.31,13.45L508.9,368.83Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "565.77 296.48 540.75 285.45 537.95 274.66 508.75 288.47 502.63 281.71 500.07 289.33 493.67 291.42 481.08 316.24 478.76 373.77 478.98 388.71 565.28 389.28 564.58 364.82 565.77 296.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566.44,298.62s-3.26.95-11.65,5.42c-8.21,4.38-17.55,8.39-17.55,8.39l.71,13.18L569,310",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "502.63 281.71 508.75 288.47 505.48 302.6 500.03 289.83"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M537.13,313.88c-.27.21-2,16.32-2,16.32l31.15-18.82L538,325.61Z",
    transform: "translate(-28.49 -23.96)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M537.41,412.86s-.64-23.88-.07-38.85c.47-12.33-1.47-43.76-1.47-43.76l-4.06-.65a458,458,0,0,0-10.42,68l-1.15,15.15",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M586.86,349.49a6.43,6.43,0,0,1,.29,1.27c.17.9.38,2.08.64,3.5.52,3,1.21,7.07,2,11.55s1.46,8.6,1.9,11.57c.22,1.48.39,2.68.5,3.52a8.14,8.14,0,0,1,.12,1.3,7.83,7.83,0,0,1-.29-1.28c-.16-.9-.38-2.07-.63-3.49-.53-3-1.24-7.08-2-11.55s-1.42-8.61-1.87-11.57c-.2-1.43-.36-2.62-.49-3.52A7.8,7.8,0,0,1,586.86,349.49Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M596.12,322.34c0,.07-.84.76-2.1,2.06a25.4,25.4,0,0,0-6.6,12.28c-.39,1.77-.48,2.9-.56,2.89a2.76,2.76,0,0,1,0-.8,15,15,0,0,1,.26-2.15,22.93,22.93,0,0,1,6.68-12.44,15.62,15.62,0,0,1,1.66-1.4A3.27,3.27,0,0,1,596.12,322.34Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "508.85 294.77 506.06 293.69 503.43 298.21 502.95 305.64 506.67 306.24 509.46 301.65 508.85 294.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M507.26,340.83c.12,0,.21,16.08.21,35.92s-.09,35.92-.21,35.92-.22-16.08-.22-35.92S507.14,340.83,507.26,340.83Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M537.54,312.31c.05,0-.6,1-1.59,2.69s-2.29,4-3.54,6.62l-.29.64-.2.42-.19-.42a50.76,50.76,0,0,1-2.6-6.58c-.27-.86-.47-1.56-.58-2a2.57,2.57,0,0,1-.14-.77c.06,0,.39,1,1,2.71a69.78,69.78,0,0,0,2.71,6.5h-.39c.09-.21.19-.42.29-.64a54.55,54.55,0,0,1,3.67-6.6c.53-.81,1-1.45,1.3-1.88A3.06,3.06,0,0,1,537.54,312.31Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M569.25,309.41l-.43.26-1.26.66-4.64,2.4c-3.92,2-9.28,4.94-15.23,8.12-3.62,1.92-7.05,3.71-10,5.2l-.27.14v-.3c0-3.87-.07-7.13-.09-9.49,0-1.11,0-2,0-2.67a5,5,0,0,1,0-1,5.45,5.45,0,0,1,.08.94c0,.68.06,1.57.1,2.68.06,2.35.15,5.61.25,9.48l-.28-.17c3-1.52,6.38-3.32,10-5.25,5.94-3.17,11.33-6,15.29-8,2-1,3.58-1.76,4.7-2.29l1.3-.58A2.42,2.42,0,0,1,569.25,309.41Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M511,319.57c.06,0-.43.87-1.06,2.28a25.86,25.86,0,0,0-1.78,5.73,25.37,25.37,0,0,0-.38,6c.09,1.54.25,2.49.18,2.5a1.89,1.89,0,0,1-.19-.65,13.31,13.31,0,0,1-.29-1.83,21.74,21.74,0,0,1,2.18-11.87,15.36,15.36,0,0,1,.92-1.61C510.84,319.75,511,319.56,511,319.57Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M534.48,330.68c-.06.1-.77-.23-1.58-.74s-1.41-1-1.34-1.11.77.23,1.57.74S534.54,330.58,534.48,330.68Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M535.82,328.86a40.7,40.7,0,0,1-3.38-7.69,42.48,42.48,0,0,1,3.38,7.69Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.41,394.65a2.79,2.79,0,0,0-1-1.82c-1-.67-2.33.21-3.39.84-2.78,1.66-6.22,1.6-9.46,1.46a239.37,239.37,0,0,1-29.15-2.77c-4.71-.79-9.47-1.82-13.69-4.08s-7.89-5.89-9.25-10.47l-2.25-1.23c1.75,3.73,1.57,14.28,2.19,18.35s2.43,7,6.35,8.24a13.76,13.76,0,0,0,4.92.34c16.06-.79,32.27-.07,48.33-.86,2.29-.12,5-.43,6.18-2.37C554.27,398.65,553.86,396.53,553.41,394.65Z",
    transform: "translate(-28.49 -23.96)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M613.76,403.82a.93.93,0,0,1-.11-.19l-.29-.56-.47-.93L612.1,401a43.18,43.18,0,0,0-6.23-6.78c-2.91-2.67-6.59-5.67-10.73-9.11-2.06-1.73-4.26-3.55-6.46-5.57a60.34,60.34,0,0,1-6.47-6.74l.31,0L570,385.86l-1.67,1.75,0-.28c4.73,6.92,9,13.61,13.55,19.22a92.63,92.63,0,0,0,6.8,7.6,57.63,57.63,0,0,0,6.62,5.89c4.32,3.26,8.66,4.67,11.68,4.59.38,0,.73,0,1.07,0l.93-.1.79-.09.65-.15.88-.19.31-.05-.29.09-.88.24-.65.17-.8.1-.93.12c-.34,0-.7,0-1.08,0-3,.12-7.48-1.26-11.86-4.52a56.23,56.23,0,0,1-6.69-5.88,91.67,91.67,0,0,1-6.86-7.61c-4.55-5.61-8.87-12.31-13.59-19.21l-.1-.15.12-.12,1.67-1.75,12.52-13.07.17-.17.14.19a61.27,61.27,0,0,0,6.42,6.7c2.18,2,4.36,3.85,6.41,5.59,4.13,3.45,7.8,6.49,10.68,9.19a40.91,40.91,0,0,1,6.18,6.89c.28.45.54.85.77,1.21l.43,1c.11.24.2.43.26.58S613.77,403.82,613.76,403.82Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.28,391.37l-1.36-.41c1.17,6.75,4.87,16.3,8.22,22.28h9.76C584.2,408.62,571.28,391.37,571.28,391.37Z",
    transform: "translate(-28.49 -23.96)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M580.45,374.54,560.7,353l-11.84-2.25-13.44,1.71a2.88,2.88,0,0,0,1.7,3.26l-5,.28a2.82,2.82,0,0,0,1.84,3.69l-3.55.63a5.1,5.1,0,0,0,5.54,2.92,76.94,76.94,0,0,1,10.49-.71l7,3.83-10.36-.43-7.52,1.42s-1,1.93.71,2.38,8.23,0,8.23,0l9.38,3s3.67,5.21,5,6.63,7.37,4,7.37,4l3,2.69Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M532.16,356a18.26,18.26,0,0,0,3.85-.14c2.38-.18,5.65-.49,9.26-.88l3.46-.39h-.14c2.69.75,5,1.38,6.69,1.8a11.77,11.77,0,0,0,2.69.54,11,11,0,0,0-2.56-1c-1.63-.54-3.94-1.26-6.61-2.06l-.07,0h-.08l-3.46.36c-3.61.39-6.88.79-9.23,1.11A20.29,20.29,0,0,0,532.16,356Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M531.3,360.14a16.8,16.8,0,0,0,3.5-.24c2.14-.24,5.1-.63,8.36-1.11l3.24-.49-.19,0c4.66,1.81,8.1,3,8.17,2.87s-3.27-1.65-7.89-3.56l-.09,0-.11,0-3.24.46c-3.26.48-6.21,1-8.33,1.33A15.1,15.1,0,0,0,531.3,360.14Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M481,356.78l10,37.82a4.69,4.69,0,0,0,4.64,3.5l51.84-1a4.7,4.7,0,0,0,4.51-5.67l-7.64-36.22a4.68,4.68,0,0,0-4.6-3.73H485.14A4.23,4.23,0,0,0,481,356.78Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M514.92,366.7a2.54,2.54,0,1,1-3.66,1A2.69,2.69,0,0,1,514.92,366.7Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M477.27,365.06a3.38,3.38,0,0,1,0-4.16A5.17,5.17,0,0,1,481.2,359a11.46,11.46,0,0,1,4.39.91,28.59,28.59,0,0,1,5,2.49,4.73,4.73,0,0,1,2.49,2.9c.21,1.29-1.19,2.77-2.33,2.12a5.51,5.51,0,0,1,3.21,3.83c.24,1.64-.64,2.52-2.22,3a2.48,2.48,0,0,1,1.42,3.16,2.83,2.83,0,0,1-3.55,1.08,8.19,8.19,0,0,1-3.09-2.59,7.6,7.6,0,0,1,.88,5.2,10.18,10.18,0,0,1-6.65-8.17,4.7,4.7,0,0,1-1.28-5.78,4.89,4.89,0,0,1-2.9-4.07",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M491.69,374.29a13.76,13.76,0,0,1-1.52-1.16,10.21,10.21,0,0,0-4-2,5.53,5.53,0,0,0-2.43,0A4.4,4.4,0,0,0,482,372a6,6,0,0,0-1.16,1.45s0-.19.14-.5a3.48,3.48,0,0,1,.84-1.16,4.47,4.47,0,0,1,1.86-1,5.54,5.54,0,0,1,2.6,0,9.43,9.43,0,0,1,4.08,2.21A7.21,7.21,0,0,1,491.69,374.29Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M491.3,367.61a8.24,8.24,0,0,1-1.84-.77c-.56-.26-1.21-.58-2-.85a16.82,16.82,0,0,0-2.52-.65,7.13,7.13,0,0,0-2.56,0,4.7,4.7,0,0,0-1.89.82,4.77,4.77,0,0,0-1.24,1.48s0-.2.15-.52a3.34,3.34,0,0,1,.92-1.17,4.63,4.63,0,0,1,2-1,7.15,7.15,0,0,1,2.69,0,13.81,13.81,0,0,1,2.58.7,17.34,17.34,0,0,1,2,.94A13.51,13.51,0,0,1,491.3,367.61Z",
    transform: "translate(-28.49 -23.96)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble2",
    "data-name": "Speech Bubble2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M469.28,282.59l-12.65-.28a29.49,29.49,0,1,0,3.12,10.09v0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M469.28,282.59l-9.46,9.89-.1.1-.05-.13h0l.17-.05a30.22,30.22,0,0,1,0,7.07,29.51,29.51,0,0,1-2.17,8.12,26.54,26.54,0,0,1-2.19,4.13c-.45.66-.88,1.35-1.37,2s-1.05,1.29-1.6,1.95A29.69,29.69,0,0,1,433,325.42a29.41,29.41,0,0,1-12.33-1.57,30.12,30.12,0,0,1-11.07-7,29.14,29.14,0,0,1-7.16-11.64l-.51-1.71c-.18-.56-.26-1.16-.39-1.74a17.13,17.13,0,0,1-.31-1.74l-.18-1.76a11.34,11.34,0,0,1-.08-1.75c0-.58,0-1.17,0-1.75l.15-1.73a16.82,16.82,0,0,1,.21-1.72,30.21,30.21,0,0,1,5-12.37,29.14,29.14,0,0,1,9.3-8.57,29.91,29.91,0,0,1,21.94-3.17,31.93,31.93,0,0,1,8.88,3.82,29.1,29.1,0,0,1,6.36,5.48,30.27,30.27,0,0,1,3.93,5.79l-.08,0,12.65.37-12.65-.2h-.05l0,0a30,30,0,0,0-3.93-5.73,29.16,29.16,0,0,0-6.33-5.41,31.71,31.71,0,0,0-8.82-3.76,29.68,29.68,0,0,0-21.7,3.19,28.8,28.8,0,0,0-9.18,8.48,29.71,29.71,0,0,0-5,12.23,13.85,13.85,0,0,0-.21,1.7c-.05.56-.09,1.14-.14,1.71s0,1.15,0,1.72a12.67,12.67,0,0,0,.08,1.74l.18,1.73a16.75,16.75,0,0,0,.31,1.72c.13.57.2,1.16.38,1.72l.51,1.69a28.76,28.76,0,0,0,7.07,11.5,29.77,29.77,0,0,0,10.93,6.94,29,29,0,0,0,12.18,1.56,29.46,29.46,0,0,0,19.4-9.59l1.59-1.92c.48-.67.91-1.35,1.36-2a26.48,26.48,0,0,0,2.19-4.08,29.85,29.85,0,0,0,2.18-8,30.57,30.57,0,0,0,0-7l-.08-.68.25.64h0l-.15,0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M421.79,295.18a3,3,0,1,1-3-3A3,3,0,0,1,421.79,295.18Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M433.76,295.18a3,3,0,1,1-3-3A3,3,0,0,1,433.76,295.18Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M445.7,293.68a3,3,0,1,1-4.08-1.09A3,3,0,0,1,445.7,293.68Z",
    transform: "translate(-28.49 -23.96)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character_3",
    "data-name": "Character 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 311.01,
    y: 19.32,
    width: 227.56,
    height: 166.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M567.06,209.64c0-1.75-.09-65.55-.22-166.36l.22.21-227.54,0h0l.26-.26c0,59.69,0,116.27,0,166.36l-.24-.24,227.56.24-227.56.24h-.24v-.24c0-50.09,0-106.67,0-166.36V43h.28l227.54,0h.21v.21C567.14,144.09,567.06,207.89,567.06,209.64Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.83,67.49c0,.14-50.84.26-113.53.26s-113.53-.12-113.53-.26,50.82-.26,113.53-.26S567.83,67.35,567.83,67.49Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.09,54.87a3.43,3.43,0,1,1-3.43-3.43A3.43,3.43,0,0,1,354.09,54.87Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.42,54.87A3.43,3.43,0,1,1,361,51.44,3.44,3.44,0,0,1,364.42,54.87Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.74,54.87a3.43,3.43,0,1,1-3.42-3.43A3.43,3.43,0,0,1,374.74,54.87Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M354.29,109.14l1.44-.92a5.4,5.4,0,0,1,7.63,2c2.31,4.21,5.18,10.08,5.18,10.08l-6.07,9.6-2,.06c-2.2,1.41-7.36-1.44-10.85-3.55s-1.77-4.25-1.77-4.25c-2.18-3,.83-4.25.83-4.25a3.25,3.25,0,0,1,.89-4.6",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 312.91,
    y: 82.43,
    width: 44.64,
    height: 62.51,
    transform: "translate(-43.9 41.17) rotate(-10.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M319.19,148.58l-.06-.28q-.08-.3-.18-.84c-.15-.77-.38-1.88-.66-3.31-.58-2.93-1.42-7.18-2.47-12.56-2.11-10.84-5.1-26.2-8.62-44.36l-.05-.23.23,0,43.84-8.43h0l.26,0,0,.26c4.38,23,8.44,44.25,11.71,61.4l0,.21-.21,0-32,6L322.27,148l-2.3.41c-.52.1-.78.13-.78.13l.81-.18,2.33-.47,8.84-1.75L363,140l-.16.25c-3.3-17.15-7.39-38.4-11.82-61.38l.31.2h0l-43.84,8.38.19-.27c3.42,18.11,6.32,33.43,8.36,44.25L318.38,144c.26,1.46.47,2.58.61,3.37.07.37.12.66.16.87A1.67,1.67,0,0,1,319.19,148.58Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M314.75,101.25c0-.14,7.21-1.64,16.16-3.36s16.23-3,16.26-2.85S340,96.69,331,98.4,314.77,101.39,314.75,101.25Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M315.58,105.59c0-.14,7.21-1.65,16.16-3.36s16.23-3,16.26-2.86-7.21,1.65-16.16,3.37S315.6,105.73,315.58,105.59Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M316.41,109.92c0-.14,7.21-1.64,16.16-3.36s16.24-3,16.26-2.85-7.21,1.65-16.16,3.36S316.43,110.06,316.41,109.92Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M317.24,114.26c0-.14,7.21-1.65,16.16-3.36s16.24-3,16.26-2.86-7.21,1.65-16.16,3.37S317.27,114.4,317.24,114.26Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M318.07,118.59c0-.14,7.21-1.64,16.16-3.36s16.24-3,16.26-2.85-7.2,1.65-16.16,3.36S318.1,118.73,318.07,118.59Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M318.9,122.93c0-.14,7.21-1.65,16.16-3.36s16.24-3,16.26-2.86-7.2,1.65-16.16,3.37S318.93,123.07,318.9,122.93Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M319.73,127.26c0-.14,7.21-1.64,16.16-3.36s16.24-3,16.27-2.85S345,122.7,336,124.41,319.76,127.4,319.73,127.26Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M320.56,131.6c0-.14,7.21-1.65,16.16-3.36s16.24-3,16.27-2.86-7.21,1.65-16.17,3.37S320.59,131.74,320.56,131.6Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M321.39,135.93c0-.14,7.21-1.64,16.16-3.36s16.24-3,16.27-2.85-7.21,1.65-16.17,3.36S321.42,136.07,321.39,135.93Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M345.23,82.21a4.26,4.26,0,0,1,.32,1.09l.66,3c.06.32.13.65.21,1a2.46,2.46,0,0,1-4.83.94l-.14-.71c-.09-.48-.18-1-.28-1.45q-.27-1.45-.54-2.85c-.08-.46-.17-.91-.25-1.35a4.83,4.83,0,0,1-.14-1.38,3.23,3.23,0,0,1,1.19-2.26,3.28,3.28,0,0,1,2.1-.72,3.14,3.14,0,0,1,2.66,1.59,2.58,2.58,0,0,1,.29.81c0,.19,0,.29,0,.3a7.87,7.87,0,0,0-.49-1,3,3,0,0,0-2.48-1.33,2.89,2.89,0,0,0-1.83.68,2.84,2.84,0,0,0-1,2,4.66,4.66,0,0,0,.15,1.24c.08.45.17.9.26,1.36.18.92.36,1.87.55,2.85.1.48.19,1,.28,1.44l.13.71a1.93,1.93,0,0,0,.22.58,2,2,0,0,0,2,1,2,2,0,0,0,1.6-1.35,2.09,2.09,0,0,0,.08-1c-.06-.34-.12-.68-.17-1-.2-1.2-.37-2.22-.5-3A5.2,5.2,0,0,1,345.23,82.21Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M358.28,107.39c-.33,0-13.32,2-13.32,2-.23,1.2.47,2.89,3.53,2.94,2.9.05,5.52-.2,5.52-.2s3.21,6.7,6.37,7.45,1.61-6.44,1.61-6.44h0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M507.14,65.09c1.13-2.62,2.27-5.32,2.38-8.19s-1.07-6-3.55-7.27c-2.28-1.2-5.09-.64-7.52-1.5-3-1.07-4.88-4.09-6.21-7.05s.52-4-1.73-6.35c-3-3-4.92-3.49-8.69-1.63-2.71-1.92-12.14-5.4-14.86-5.49-4-.12-8.62.2-11.44,3.09-2.18,2.24-3.57,5.1-6.25,6.71-3.69,2.22-8.39.33-12.69.49A2.46,2.46,0,0,0,434.31,39a2.66,2.66,0,0,0,.35,2.17L438,48.07a6.58,6.58,0,0,1-5.76-.14,19.54,19.54,0,0,0,5.11,12.31,1.66,1.66,0,0,0-2.29.88,4.19,4.19,0,0,0,0,2.75,20.15,20.15,0,0,0,27.36,13.26l23.72,1.79a6,6,0,0,0,4.09,3.8c2.65-2,3.08-3.07,3.08-3.07,1.63,1.21.35.6,1.63,1.21,2.94,1.4,7.29-.26,8-3.54a6.91,6.91,0,0,1,1.57-3.61A12.38,12.38,0,0,1,508,71.79a9.7,9.7,0,0,0,4.34-4.45A7,7,0,0,1,507.14,65.09Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M490.36,54.92l.61,49c.1,8.32-1.45,20.57-14.62,20.14h0c-11.4-1.24-14.43-12-14.51-19.8,0-3.69-.09-6.76-.12-7.14,0,0-12.48-1-13.53-13.35-.51-5.95-.56-18.31-.47-29.48a23,23,0,0,1,21.37-22.79l1.19-.09C483.17,31.19,490.53,42,490.36,54.92Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M461.72,97.09a29.89,29.89,0,0,0,15.72-5.92s-3.26,9.29-15.65,9.08Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M468.79,59.31c.24.25,1.67-.9,3.73-1s3.61,1,3.83.69-.15-.57-.83-1a5.19,5.19,0,0,0-3.07-.87,5,5,0,0,0-3,1.08C468.87,58.73,468.67,59.2,468.79,59.31Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M468.42,63.9a1.66,1.66,0,0,0,1.73,1.56,1.58,1.58,0,0,0,1.6-1.62A1.66,1.66,0,0,0,470,62.27,1.59,1.59,0,0,0,468.42,63.9Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M463.62,73.67a13.58,13.58,0,0,0-3.12-.33c-.49,0-1-.07-1.06-.4a2.43,2.43,0,0,1,.22-1.46l1.16-3.79c1.6-5.39,2.73-9.81,2.51-9.87s-1.7,4.25-3.3,9.65c-.38,1.33-.75,2.59-1.1,3.81a2.81,2.81,0,0,0-.11,1.91,1.18,1.18,0,0,0,.84.65,3.11,3.11,0,0,0,.83.06A12.33,12.33,0,0,0,463.62,73.67Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M469.67,51.54c.2.46,1.85.12,3.83.22s3.61.54,3.84.1c.1-.21-.21-.63-.88-1a6.47,6.47,0,0,0-5.85-.24C469.92,50.93,469.58,51.33,469.67,51.54Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M450.06,55.37c.21.37,1.82,0,3.78-.1s3.57.19,3.78-.2c.09-.19-.24-.52-.92-.82a6.81,6.81,0,0,0-2.88-.47,7,7,0,0,0-2.88.7C450.27,54.83,450,55.19,450.06,55.37Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M490,64.13c.2-.1,8.29-3.12,8.64,5.33s-8.21,7.06-8.24,6.82S490,64.13,490,64.13Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M492.87,73s.15.09.41.2a1.49,1.49,0,0,0,1.1,0c.88-.37,1.57-1.82,1.55-3.34a4.81,4.81,0,0,0-.5-2.09,1.7,1.7,0,0,0-1.15-1.09.75.75,0,0,0-.85.44c-.11.24-.05.41-.09.42s-.19-.13-.14-.48a.94.94,0,0,1,.32-.55,1.07,1.07,0,0,1,.8-.24,2,2,0,0,1,1.59,1.24,4.93,4.93,0,0,1,.61,2.34c0,1.7-.79,3.33-2,3.74a1.56,1.56,0,0,1-1.35-.17C492.9,73.17,492.84,73,492.87,73Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M465.61,79.53c-.09-.22,1.56-.71,2.73-2.27a9.34,9.34,0,0,0,1.17-2.2c.25-.62.43-1,.52-1s.07.44-.07,1.11a6.21,6.21,0,0,1-1.09,2.47,5,5,0,0,1-2.15,1.65C466.07,79.58,465.63,79.6,465.61,79.53Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M501.26,50.45c-1.76-3-2.17-6.54-3.14-9.87s-2.81-6.77-6.07-7.94l-.08,0c-2.93-1.18-6.54-1.2-8.94.83-.6-4.39-4.45-7.87-8.74-9s-11.17-.46-15.28,1.2c-3.18,1.28-6.25,3.9-10,7.75a41.59,41.59,0,0,0-4.31,5.23L441,50.22a4.55,4.55,0,0,0-1.05,1.05,2.17,2.17,0,0,0,3.17,2.9l0,0c.38.65.67,1.31,1,2v0l.06.12a13,13,0,0,0,.63,1.23v0l2.88,12.73c.19-3.47-.07-15.54.11-19a19.39,19.39,0,0,0,13.8-6.37c1.89-2.1,3.38-4.73,5.92-6,3.27-1.62,7.16-.44,10.61.76l-.15-.13a15.51,15.51,0,0,1,4.78,3.44,48,48,0,0,0,2.08,20.36c.32,1,1.2,3,2.17,3.39,1.9.73,2.41-1.2,3.55-2.23a5.09,5.09,0,0,1,3.46-.85,76.87,76.87,0,0,0,2.32-8.77,7.75,7.75,0,0,0,3.55.24c-.37-.87-.73-1.74-1.1-2.62a4.09,4.09,0,0,0,1.52.69,1.36,1.36,0,0,0,1.44-.63C502.06,51.82,501.63,51.07,501.26,50.45Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M479.15,34.93a12,12,0,0,1,1.23,1.13,8.81,8.81,0,0,1,1.9,4.09,16,16,0,0,1,.31,3.14c0,1.13-.09,2.35-.17,3.63a29.83,29.83,0,0,0-.09,4,14.39,14.39,0,0,0,.27,2.14,4.54,4.54,0,0,0,.87,2.07,1.86,1.86,0,0,0,1.74.58,2.8,2.8,0,0,0,1.57-.88A6.47,6.47,0,0,0,488,51.73l-.26,0a10.51,10.51,0,0,0,1.5,2.59,3.7,3.7,0,0,0,2.4,1.3,2.38,2.38,0,0,0,1.27-.22,2,2,0,0,0,.86-.85,2.06,2.06,0,0,0,.26-1.09,1.51,1.51,0,0,0-.39-1l-.13.11a7.78,7.78,0,0,0,2.65,2A7.2,7.2,0,0,0,497,55a1,1,0,0,0,.29.07,1.2,1.2,0,0,0-.28-.12c-.18-.07-.45-.18-.79-.35a8.29,8.29,0,0,1-2.56-2l-.13.12a1.58,1.58,0,0,1,.08,1.83,1.88,1.88,0,0,1-.78.75,2.13,2.13,0,0,1-1.15.19,3.44,3.44,0,0,1-2.23-1.24A10.5,10.5,0,0,1,488,51.65l-.18-.4-.08.43a6.29,6.29,0,0,1-1.13,3,2.53,2.53,0,0,1-1.4.79,1.59,1.59,0,0,1-1.48-.5,4.11,4.11,0,0,1-.81-1.93,13.75,13.75,0,0,1-.27-2.09,33.14,33.14,0,0,1,.07-4c.08-1.28.17-2.5.15-3.65a15.55,15.55,0,0,0-.35-3.18,8.73,8.73,0,0,0-2-4.12A5,5,0,0,0,479.15,34.93Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441,46.93l.1.08.31.23a6.09,6.09,0,0,0,.52.33,7.36,7.36,0,0,0,.75.39,10.82,10.82,0,0,0,5.28.95,13.91,13.91,0,0,0,7.44-2.74,24,24,0,0,0,6.39-7.37c.9-1.49,1.63-3,2.44-4.44A16.37,16.37,0,0,1,467,30.61a8.39,8.39,0,0,1,3.56-2.16,5.75,5.75,0,0,1,1.87-.21,6.4,6.4,0,0,1,1.72.33,7.1,7.1,0,0,1,2.57,1.54,7.2,7.2,0,0,1,1.39,1.81,7.91,7.91,0,0,1,.63,1.85s0-.05,0-.13,0-.23,0-.38a6.43,6.43,0,0,0-.47-1.39A7.08,7.08,0,0,0,476.81,30a7.28,7.28,0,0,0-2.62-1.63,7,7,0,0,0-1.77-.36,6.27,6.27,0,0,0-1.95.21,8.68,8.68,0,0,0-3.67,2.2,16.54,16.54,0,0,0-2.82,3.8c-.81,1.43-1.54,3-2.43,4.43a24.25,24.25,0,0,1-6.3,7.3,13.87,13.87,0,0,1-7.3,2.76,11,11,0,0,1-5.22-.85A19.58,19.58,0,0,1,441,46.93Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.88,41.51a2.21,2.21,0,0,0,.44.31,10.38,10.38,0,0,0,1.31.66,12.39,12.39,0,0,0,2.08.68,13.49,13.49,0,0,0,5.32.17,12.63,12.63,0,0,0,2.11-.54,11.66,11.66,0,0,0,1.35-.58,3,3,0,0,0,.46-.28s-.71.3-1.87.66a14.65,14.65,0,0,1-2.1.48,16.48,16.48,0,0,1-2.61.16,15.63,15.63,0,0,1-2.6-.33,13.89,13.89,0,0,1-2.06-.61C440.57,41.85,439.91,41.46,439.88,41.51Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M450,60.09c.25.25,1.67-.9,3.74-1s3.6,1,3.82.69-.15-.58-.82-1a5.21,5.21,0,0,0-3.07-.87,4.88,4.88,0,0,0-3,1.08C450,59.51,449.84,60,450,60.09Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M451.13,64.18a1.67,1.67,0,0,0,1.73,1.56,1.59,1.59,0,0,0,1.61-1.62,1.67,1.67,0,0,0-1.73-1.57A1.61,1.61,0,0,0,451.13,64.18Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.77,110l-44.6,29.19L370,118l-8.46,13.41s15.82,18.31,21.68,24.53,9.78,9.53,14.39,8.94,43.24-15.59,43.24-15.59l5.86-40.94-2.46.59A7.66,7.66,0,0,0,441.77,110Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.54,100c-10,6.27-20,8.63-30.22,4.57L446,108.48l-7.44,12.94a11.74,11.74,0,0,0-1.53,6.71L440,177.66l-9,31.46,88.32.76-4.35-23.37-10.95-84Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M505,140.22l-2.76-37.92s20.79,1.92,27.67,16.59c5.79,12.36,23.19,48.29,24.9,53.37,5,14.93-4.22,36.71-36.59,35.52l-3.69-20.29Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M521.65,171.79a9.55,9.55,0,0,0,.51,1.49c.36.91.89,2.15,1.5,3.5l1.56,3.47a10.91,10.91,0,0,0,.68,1.42,9.1,9.1,0,0,0-.52-1.49c-.35-.91-.88-2.14-1.49-3.5s-1.13-2.51-1.56-3.47A11.82,11.82,0,0,0,521.65,171.79Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M510.14,141.94c.07,0,.13-2.4.13-5.36s-.06-5.37-.13-5.37-.12,2.4-.12,5.37S510.08,141.94,510.14,141.94Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M513.2,125.8a2.49,2.49,0,0,0,.19-.6c.1-.39.27-1,.5-1.63a26.83,26.83,0,0,1,2.31-5.1,26.23,26.23,0,0,1,3.34-4.5c.48-.53.89-1,1.18-1.23a3.26,3.26,0,0,0,.43-.45,2.27,2.27,0,0,0-.49.38,14.78,14.78,0,0,0-1.25,1.18,23.51,23.51,0,0,0-5.69,9.67,14.85,14.85,0,0,0-.42,1.66A3.64,3.64,0,0,0,513.2,125.8Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M439.86,123.45a5.19,5.19,0,0,1,.12,1.24c0,.8.06,2,0,3.39,0,2.86-.33,6.8-.68,11.14a110.19,110.19,0,0,0-.44,11.11c0,1.42.08,2.58.15,3.37a6.49,6.49,0,0,1,0,1.24,5,5,0,0,1-.23-1.22c-.13-.79-.24-1.94-.32-3.37a85.67,85.67,0,0,1,.29-11.17c.35-4.35.7-8.27.83-11.12.07-1.42.11-2.57.13-3.37A6.56,6.56,0,0,1,439.86,123.45Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M534.89,178.76a9.87,9.87,0,0,1-1.42.8c-.93.49-2.25,1.22-3.86,2.19s-3.51,2.14-5.72,3.29c-1.11.57-2.29,1.14-3.53,1.68l-3.86,1.6-1.19.49.16-.29c.85,5.37,1.58,10.18,2.08,13.65.24,1.67.43,3.05.57,4.1a7.33,7.33,0,0,1,.14,1.51,9.46,9.46,0,0,1-.33-1.48c-.19-1.05-.43-2.42-.73-4.07-.6-3.46-1.39-8.26-2.25-13.62l0-.21.19-.08,1.19-.48,3.86-1.59c1.24-.53,2.41-1.08,3.51-1.64,2.21-1.11,4.12-2.26,5.76-3.18s3-1.62,4-2.05c.48-.23.85-.38,1.11-.49S534.88,178.74,534.89,178.76Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M539.6,172.26c0,.09-1.05.29-2.67.9a20.69,20.69,0,0,0-5.8,3.35,20.42,20.42,0,0,0-4.39,5.06c-.9,1.47-1.3,2.48-1.39,2.45a2.26,2.26,0,0,1,.2-.74,13.32,13.32,0,0,1,.87-1.9,18.38,18.38,0,0,1,10.39-8.57,12.72,12.72,0,0,1,2-.49A2.43,2.43,0,0,1,539.6,172.26Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M506,209.48l21.7-52.36c1-2.39-.25-4.33-2.78-4.33h-4.36c-1.78,0-3-1-3.11-2.51l-.15-1.92c-.11-1.54-1.33-2.52-3.11-2.52H493.4a7.24,7.24,0,0,0-4.8,2.13l-1.69,1.63a7.23,7.23,0,0,1-4.8,2.12H455.69a7.38,7.38,0,0,0-6.31,4.33l-21.51,53.43Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506,209.48l21.7-52.36c1-2.39-.25-4.33-2.78-4.33h-4.36c-1.78,0-3-1-3.11-2.51l-.15-1.92c-.11-1.54-1.33-2.52-3.11-2.52H493.4a7.24,7.24,0,0,0-4.8,2.13l-1.69,1.63a7.23,7.23,0,0,1-4.8,2.12H455.69a7.38,7.38,0,0,0-6.31,4.33l-21.51,53.43Z",
    transform: "translate(-28.49 -23.96)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.54,191.7l8.19-31.65c.54-2.08-.83-4.17-2.73-4.17H450.85a2.92,2.92,0,0,0-2.73,2.35l-11.91,47.63c-.53,2.09.31,3.35,2.21,3.33H503a2.91,2.91,0,0,0,2.69-2.33Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M505.11,208l3.49-49.83a3.06,3.06,0,0,0-3.05-3.27H439.08V208Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M505.85,209.19,498,157.81a3.69,3.69,0,0,0-3.62-2.87H427.09A3.64,3.64,0,0,0,423.7,160l14.52,47Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M506,209.45l-16.31-48.11a4.83,4.83,0,0,0-4.54-3.35H415.79a3.39,3.39,0,0,0-3.09,4.5l15.17,47Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.44,201.4s2.62.12,3.83.2a35.57,35.57,0,0,0,16.84-3c1.63-.72,3.35-1.75,3.85-3.47.55-1.92-.69-3.92-2.21-5.22s-3.37-2.23-4.68-3.74-1.94-3.94-.65-5.46l.36.27c.94,2.37,3.55,3.52,5.71,4.88A20.13,20.13,0,0,1,504,196.93c.76,2.49,1,5.4-.55,7.52a9.36,9.36,0,0,1-4.55,3c-5.25,2-10.85,2-16.45,2-1.76,0-7.19-.08-7.19-.08-1.7-.46-2.27-1.35-3.29-2.79S471.19,202.43,472.44,201.4Z",
    transform: "translate(-28.49 -23.96)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M472.44,201.4l18.08-2.72,7-4a3.13,3.13,0,0,0,1.61-2.55V192a3.22,3.22,0,0,0-2-3.06c-2.23-.94-5.75-2.18-7.26-4.82-2.16-3.79,0-4.57,0-4.57l15.1,6,10.69,7.28L517.85,205l-14.92,4.87s-16.61.94-21.2.43-4.58-2.65-4.58-2.65c-.85-.27-2.58-1.78-2.57-3.19-2.23-2.09-2.14-3.07-2.14-3.07",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M495.57,206.62a3.51,3.51,0,0,0-.75.14c-.47.12-1.16.27-2,.44a44.57,44.57,0,0,1-6.73.8,43.49,43.49,0,0,1-6.76-.28c-.87-.1-1.56-.2-2-.28a3.78,3.78,0,0,0-.76-.08,4,4,0,0,0,.74.2c.47.12,1.16.25,2,.38a36.59,36.59,0,0,0,13.57-.53c.85-.2,1.53-.38,2-.53A4.05,4.05,0,0,0,495.57,206.62Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M493.91,203.82a4.47,4.47,0,0,0-.75.15c-.48.11-1.18.27-2,.43a44.15,44.15,0,0,1-6.84.76,45.51,45.51,0,0,1-6.87-.32c-.88-.1-1.58-.2-2.07-.28a3.58,3.58,0,0,0-.76-.09,3.67,3.67,0,0,0,.74.2c.48.12,1.18.25,2.06.39a39.11,39.11,0,0,0,6.91.4,36.19,36.19,0,0,0,6.87-.85,20.73,20.73,0,0,0,2-.53A3,3,0,0,0,493.91,203.82Z",
    transform: "translate(-28.49 -23.96)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Character_2",
    "data-name": "Character 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 123.8,
    y: 267.92,
    width: 227.56,
    height: 169
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M379.85,460.88c0-1.76-.09-66.7-.22-169l.21.21-227.53.05h0l.26-.26c0,60.71,0,118.23,0,169l-.24-.23,227.56.23-227.56.24h-.24v-.24c0-50.77,0-108.29,0-169v-.26h.28l227.53.05h.22v.21C379.93,394.18,379.85,459.12,379.85,460.88Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.85,314.33c0,.15-51,.27-113.8.27s-113.8-.12-113.8-.27,50.94-.26,113.8-.26S379.85,314.19,379.85,314.33Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 133.43,
    cy: 278.04,
    r: 3.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 143.52,
    cy: 278.04,
    r: 3.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 153.61,
    cy: 278.04,
    r: 3.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M354.79,426.87s5.55-7.27,8.16-7.55,19,.28,21.25,0,15.22-5.75,15.22-5.75,2.3.78,2,2.83-14.64,9.81-16.37,10.1-15.5,1.3-15.5,1.3L366.09,434Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M307.21,335.35a8.7,8.7,0,0,0,1.39-15.1l-10.08-3.38q-2.19,19.51-4.64,39a14.71,14.71,0,0,0,7.74-2.14c2.23-1.55,3.7-4.45,2.87-7a6.89,6.89,0,0,0,2.72-11.35Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M257.78,327.72l.38-4.63,28.31-2.45c8.66,0,17,9.5,16.7,18.14-.37,9.61-1.2,21.33-3.06,28.34-3.74,14.09-14.9,14.79-14.9,14.79l-1,14.2c-.75,8.28-7.89,9.39-16.17,8.65h0a15.06,15.06,0,0,1-13.69-15.85Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M298.69,349a1.86,1.86,0,0,1-2,1.68A1.77,1.77,0,0,1,295,348.8a1.85,1.85,0,0,1,2-1.68A1.77,1.77,0,0,1,298.69,349Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M299.52,344.56c-.25.21-1.54-1-3.51-1.15s-3.53.64-3.72.38.18-.53.86-.93a5.13,5.13,0,0,1,3-.6,4.9,4.9,0,0,1,2.76,1.22C299.48,344,299.65,344.46,299.52,344.56Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M280.22,347.81a1.85,1.85,0,0,1-2,1.67,1.77,1.77,0,0,1-1.73-1.85,1.85,1.85,0,0,1,2-1.67A1.77,1.77,0,0,1,280.22,347.81Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M280.05,342.94c-.25.22-1.54-.95-3.51-1.15s-3.53.65-3.72.38.18-.52.86-.92a5.05,5.05,0,0,1,3-.6,4.83,4.83,0,0,1,2.77,1.22C280,342.39,280.18,342.85,280.05,342.94Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M285.73,358.34a12.93,12.93,0,0,1,3.27-.26c.51,0,1-.05,1.12-.38a2.57,2.57,0,0,0-.18-1.53l-1.1-4c-1.52-5.68-2.56-10.34-2.33-10.4s1.64,4.5,3.16,10.19l1,4a2.93,2.93,0,0,1,.06,2,1.25,1.25,0,0,1-.9.65,3.28,3.28,0,0,1-.87,0A13,13,0,0,1,285.73,358.34Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M285.2,382a38.2,38.2,0,0,1-19.15-7.16s3.81,10.52,18.77,10.73Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M281.07,337.41c-.25.51-2.2.06-4.55.1s-4.29.48-4.54,0c-.12-.24.26-.72,1.07-1.16a7.69,7.69,0,0,1,3.46-.83,7.58,7.58,0,0,1,3.47.77C280.79,336.69,281.18,337.16,281.07,337.41Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M300.16,337.77c-.4.42-1.71-.19-3.35-.38s-3.05,0-3.32-.51c-.12-.24.14-.67.79-1a4.87,4.87,0,0,1,5.38.72C300.19,337.09,300.33,337.57,300.16,337.77Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M309.51,326.47a8.94,8.94,0,0,0,4.4-8.83,10.16,10.16,0,0,0-8.2-8.49,9.23,9.23,0,0,0-4.32-1.73,4.85,4.85,0,0,0-3.28-4.14,11.6,11.6,0,0,0-5.53-.34,9.39,9.39,0,0,0-15.12-.88,7.69,7.69,0,0,0-11.8,3.55,7.64,7.64,0,0,0-5.72,2,23.83,23.83,0,0,0-3.09,4.54,8.65,8.65,0,0,0-5.49,15.28,7.89,7.89,0,0,0,.44,12.66,10.12,10.12,0,0,0,0,8,5,5,0,0,0,2.28,2.6,1.9,1.9,0,0,0,.17.56c.72,1.43,2.88,1.06,4.23.2,3.27-2.1,5.28-5.71,6.53-9.39s1.85-7.56,3.06-11.25l.09-.26a10.46,10.46,0,0,1,2.49-4.08,26,26,0,0,0,3.21,2.55,11.47,11.47,0,0,0,13.53-1.27,16.83,16.83,0,0,0,10.25,5c3.85.4,7.74.07,10.95-2.1a5.47,5.47,0,0,0,1.92-2.24A1.64,1.64,0,0,0,309.51,326.47Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M258.16,346.89c-.18-.11-7.39-3.73-8.56,4.09s6.92,7.37,7,7.15S258.16,346.89,258.16,346.89Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M254.62,354.81s-.15.08-.39.15a1.38,1.38,0,0,1-1-.13c-.78-.43-1.28-1.84-1.11-3.26a4.4,4.4,0,0,1,.67-1.89,1.59,1.59,0,0,1,1.18-.89.71.71,0,0,1,.75.49c.07.24,0,.38,0,.4s.18-.1.17-.43a.86.86,0,0,0-.24-.54,1,1,0,0,0-.72-.31,1.91,1.91,0,0,0-1.6,1,4.75,4.75,0,0,0-.8,2.11c-.18,1.58.4,3.17,1.48,3.67a1.5,1.5,0,0,0,1.28,0C254.58,355,254.65,354.83,254.62,354.81Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.65,316.3a1.81,1.81,0,0,1,0,.2,3,3,0,0,1,.07.58,5.83,5.83,0,0,1-.3,2.21,5.93,5.93,0,0,1-2,2.85,6.25,6.25,0,0,1-4.39,1.25l.15-.11a13.46,13.46,0,0,1-4,6.44,10.31,10.31,0,0,1-3.75,2.19,8.7,8.7,0,0,1-4.59.14,15.38,15.38,0,0,1-4.23-1.61,11.76,11.76,0,0,1-3.36-2.61l.23,0a14.34,14.34,0,0,1-7,2.88,11.23,11.23,0,0,1-5.84-1.19,11.69,11.69,0,0,1-3.16-2.31,9.93,9.93,0,0,1-.69-.78,1.23,1.23,0,0,1-.21-.3s.32.37,1,1a12.14,12.14,0,0,0,3.17,2.2,11.25,11.25,0,0,0,5.72,1.09,14.21,14.21,0,0,0,6.83-2.86l.13-.1.1.13a11.66,11.66,0,0,0,3.27,2.51,15.22,15.22,0,0,0,4.13,1.57,8.43,8.43,0,0,0,4.41-.12,10.18,10.18,0,0,0,3.64-2.12,13.38,13.38,0,0,0,4-6.25l0-.12h.12a5.94,5.94,0,0,0,4.22-1.15,5.82,5.82,0,0,0,2-2.72,6.27,6.27,0,0,0,.37-2.15C313.67,316.57,313.63,316.3,313.65,316.3Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258,311.86a18.19,18.19,0,0,0-1,2.6,11.31,11.31,0,0,0,.38,7.13l.05.12-.11.08a7.32,7.32,0,0,0-2.49,2.92,7,7,0,0,0-.58,4.16,7.31,7.31,0,0,0,2.81,4.58l.14.1-.1.14a9.18,9.18,0,0,0-1.53,4.77,10.06,10.06,0,0,0,.65,4,11.44,11.44,0,0,0,1.87,3.06,1.62,1.62,0,0,1-.18-.16,6.66,6.66,0,0,1-.5-.52,8.92,8.92,0,0,1-1.39-2.3,9.82,9.82,0,0,1-.74-4,9.24,9.24,0,0,1,1.54-4.95l0,.23a7.58,7.58,0,0,1-3-4.8,7.27,7.27,0,0,1,.62-4.37,7.47,7.47,0,0,1,2.62-3l-.06.19a11.2,11.2,0,0,1-.26-7.3,10.72,10.72,0,0,1,.81-1.93c.12-.21.22-.37.29-.47S258,311.85,258,311.86Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M252.44,357.31a6.63,6.63,0,0,0-.34,1.39,2.14,2.14,0,0,0,.39,1.39,1.75,1.75,0,0,0,1.55.67,1.45,1.45,0,0,0,1.15-1.16,2.83,2.83,0,0,0-.08-1.49c-.28-.84-.56-1.34-.5-1.36a3.71,3.71,0,0,1,.74,1.28,2.91,2.91,0,0,1,.16,1.65,2.08,2.08,0,0,1-.44.91,1.61,1.61,0,0,1-1,.53,2,2,0,0,1-1.86-.83,2.29,2.29,0,0,1-.38-1.61A2.13,2.13,0,0,1,252.44,357.31Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M280.59,360.68a3.63,3.63,0,0,0,.59,5.92,2.1,2.1,0,0,0,1.33.31c.81-.12,1.36-.87,1.82-1.55l1.14-1.69a.86.86,0,0,0,.21-.64c-.06-.24-.31-.37-.53-.48l-4.37-2.09",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M282.46,366.66a4.09,4.09,0,0,1-2-.71,3.32,3.32,0,0,1-1.52-1.88,2.49,2.49,0,0,1,0-1.48,4,4,0,0,1,1.8-2.41l.14-.08.14.08c2.82,1.73,5.09,2.78,5,2.91a19.35,19.35,0,0,1-5.31-2.43H281a3.56,3.56,0,0,0-.95.87,2.63,2.63,0,0,0,.58,4.09C281.69,366.33,282.5,366.57,282.46,366.66Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.89,460.94s28.44-51,33.18-59.25c5.57-9.7,10.42-13.22,14.78-15.34a34.43,34.43,0,0,1,14.71-3.29l14.11-.11s5.36,8,12.63,9.6c10,2.16,17.53-5.27,17.53-5.27l20.26,8.3L301,433a55.11,55.11,0,0,1-10,26.16l-1.34,1.74-74.7-.07,8.66-26.95-16,27Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.09,395.58s5.89,3.46,10.33,17.8,14,39.85,14,39.85l24-27.23,14.24,9s-23,39.88-26.62,44.6c-5.44,7-19.19,11.06-27.26,1.71-5.86-6.8-19.89-39.7-19.89-39.7Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M296.45,416.37s.1.14.23.43.32.71.53,1.27a37.84,37.84,0,0,1,1.53,4.86,42.87,42.87,0,0,1-4.93,32.43,40.24,40.24,0,0,1-2.89,4.18c-.37.47-.69.81-.89,1s-.33.36-.35.35a15.09,15.09,0,0,1,1.07-1.53,44.09,44.09,0,0,0,2.74-4.24A44.49,44.49,0,0,0,298.38,423a46.86,46.86,0,0,0-1.36-4.87A15,15,0,0,1,296.45,416.37Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M228.29,411.79a2,2,0,0,1,0,.52c-.05.4-.12.89-.2,1.48-.18,1.29-.49,3.14-.91,5.42-.83,4.56-2.19,10.83-4.07,17.66s-3.93,12.91-5.54,17.26c-.81,2.17-1.49,3.92-2,5.12l-.59,1.37a2.9,2.9,0,0,1-.23.47,1.91,1.91,0,0,1,.13-.51c.14-.37.3-.84.5-1.4l1.83-5.18c1.53-4.37,3.51-10.45,5.39-17.27s3.28-13.05,4.21-17.59l1.07-5.38.3-1.46A1.72,1.72,0,0,1,228.29,411.79Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M192.56,460.89s2.72-3.69,4.06-4.39,3.18-.68,4,.05l.81.72s4.21-1.89,6.24-.43c0,0,4-1.9,5.93.27,0,0,3.09-2,4.4-.26s1.17,4.72.54,6.25-1.82,6.73-2.74,6.82c0,0-2.46.26-2.79-1.07s-.47-2-.47-2-.94,4.71-2.08,4.94-3.3.11-3.37-2c0,0-1.05,1.57-2.08,1.11s-2.3-1.21-2.19-2.49.13-2.55.13-2.55-.56,1.86-1.49,1.46-1.87-.32-2.39-1.9-1.82-4.6-1.82-4.6Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M202.86,465.82c-.06,0,.19-.51.41-1.33a7.65,7.65,0,0,0,.13-3.27,7.53,7.53,0,0,0-1.3-3c-.49-.69-.89-1.05-.85-1.1a3,3,0,0,1,1.08.93,6.65,6.65,0,0,1,1.47,3.1,6.75,6.75,0,0,1-.26,3.43A2.87,2.87,0,0,1,202.86,465.82Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M207.92,456.86a6.23,6.23,0,0,1,.54,1.86,18.42,18.42,0,0,1-.62,9.24,6.66,6.66,0,0,1-.78,1.77,33.66,33.66,0,0,0,1.28-6.38A32.65,32.65,0,0,0,207.92,456.86Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M213.69,457.17a15.27,15.27,0,0,1,.06,5,14.85,14.85,0,0,1-1.19,4.84c-.12,0,.48-2.18.78-4.89S213.57,457.18,213.69,457.17Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M229.47,458.24a1.57,1.57,0,0,0-1.06-.86,3.4,3.4,0,0,0-3.06.82,11.65,11.65,0,0,0-2.23,2.75h6C229,460,229.8,459.09,229.47,458.24Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M383.82,375.29H415.9a32.08,32.08,0,1,1-32.14-32.07Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M389.53,370.14l-.1-32.08h.1A32.22,32.22,0,0,1,421.6,370Z",
    transform: "translate(-28.49 -23.96)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble1",
    "data-name": "Speech Bubble1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236.25,361.93l-6.25-11a29.48,29.48,0,1,0-7.06,7.86v0Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M236.25,361.93l-13.35-3.05-.13,0,.08-.11h0l.13.12a29.2,29.2,0,0,1-14.13,6,26.52,26.52,0,0,1-4.67.24c-.8-.05-1.62-.07-2.44-.13l-2.49-.38a29.71,29.71,0,0,1-18.41-11.82,29.48,29.48,0,0,1-5-11.38,30.09,30.09,0,0,1,.35-13.1,29.09,29.09,0,0,1,6.32-12.12l1.2-1.32c.39-.45.87-.81,1.29-1.22s.86-.83,1.34-1.17l1.41-1.05a12.87,12.87,0,0,1,1.47-1l1.49-.91,1.57-.76a13.09,13.09,0,0,1,1.58-.7,30,30,0,0,1,13.2-2,29.1,29.1,0,0,1,12.12,3.58,29.93,29.93,0,0,1,14,17.21,31.76,31.76,0,0,1,1.28,9.58,29.5,29.5,0,0,1-1.44,8.27,29.9,29.9,0,0,1-3,6.34v-.09c3.94,7.06,5.86,10.51,6.17,11.05l-6.33-11,0-.05,0,0a30.2,30.2,0,0,0,2.9-6.32,29.11,29.11,0,0,0,1.39-8.21,31.51,31.51,0,0,0-1.3-9.49,29.63,29.63,0,0,0-13.87-17,28.94,28.94,0,0,0-12-3.52,29.69,29.69,0,0,0-13,2,13.54,13.54,0,0,0-1.56.7l-1.55.75-1.47.9a12.46,12.46,0,0,0-1.45.95l-1.39,1.05a16,16,0,0,0-1.32,1.15c-.42.4-.89.76-1.28,1.2l-1.19,1.31a28.67,28.67,0,0,0-6.24,12,29.67,29.67,0,0,0-.35,12.94,29.17,29.17,0,0,0,4.9,11.26,29.56,29.56,0,0,0,18.2,11.73l2.46.38c.81.07,1.62.09,2.42.14a27,27,0,0,0,4.62-.22,29.26,29.26,0,0,0,8-2.25,30.23,30.23,0,0,0,6-3.6l.55-.42-.42.55h0l-.05-.14Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M196.62,335.49a3,3,0,1,1-3-3A3,3,0,0,1,196.62,335.49Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M208.59,335.49a3,3,0,1,1-3-3A3,3,0,0,1,208.59,335.49Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M220.53,334a3,3,0,1,1-4.09-1.1A3,3,0,0,1,220.53,334Z",
    transform: "translate(-28.49 -23.96)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    "data-name": "Character 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M202.61,168.72a16.85,16.85,0,0,1,8.62,7.5c3.24,5.73,2.37,8.56,1.53,11.95s-2.34,10.12-2.42,9.68S202.61,168.72,202.61,168.72Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M278.46,154.52",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 37.64,
    y: 74.9,
    width: 232.89,
    height: 172.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M299,271.82c0-1.76-.08-68.26-.21-173l.21.21-232.86.05h0l.26-.26c0,62.13,0,121,0,173l-.23-.23,232.88.23-232.88.24H65.9v-.24c0-52,0-110.83,0-173V98.6h.28l232.86,0h.22v.22C299.11,203.56,299,270.06,299,271.82Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.63,123c0,.14-51.62.26-115.29.26S68.05,123.18,68.05,123s51.61-.26,115.29-.26S298.63,122.89,298.63,123Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.37,110.41A3.43,3.43,0,1,1,77.94,107,3.43,3.43,0,0,1,81.37,110.41Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.69,110.41A3.43,3.43,0,1,1,88.27,107,3.42,3.42,0,0,1,91.69,110.41Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102,110.41A3.43,3.43,0,1,1,98.59,107,3.43,3.43,0,0,1,102,110.41Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M195,95c-.77-2.81-2.3-5.57-4.83-7-1.19-.7-2.55-1.08-3.77-1.74a46.08,46.08,0,0,1-4.06-2.95,14.45,14.45,0,0,0-21.12,5.35c-2.84-2.17-7.77-1.25-11.13,0s-6.17,5.21-7,8.69L158.89,102a42.19,42.19,0,0,0,10.76,8.86,21.83,21.83,0,0,0,13.5,2.73A14.9,14.9,0,0,0,194.26,106,15.53,15.53,0,0,0,195,95Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M206.2,147.15a9.43,9.43,0,0,0,2-13c-.89-1.15-2.1-2.2-2.3-3.64a7.24,7.24,0,0,1,.38-2.63,15.57,15.57,0,0,0-5.71-15.84c-.09-3.23-1.9-10.06-6-12.67L175.93,102q1.27,29.43-.17,58.87c-.15,3-.26,6.24,1.39,8.76,2.33,3.58,7.19,4.32,11.45,4.43a34,34,0,0,0,12.09-1.42c3.85-1.35,7.4-4,9-7.77C212.18,159.12,209.62,152.42,206.2,147.15Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M149.4,107.48l-.56-4.17,24.57-7.67c7.65-1.71,16.92,5.09,18.31,12.81,1.53,8.57,3.07,19.1,2.79,25.66-.57,13.2-10.31,16-10.31,16l1,7.82a14.46,14.46,0,0,1-12.51,16.17h0a14.45,14.45,0,0,1-16.16-12.45Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M190,118.15a1.67,1.67,0,0,1-1.41,1.86,1.6,1.6,0,0,1-1.88-1.3,1.67,1.67,0,0,1,1.41-1.86A1.58,1.58,0,0,1,190,118.15Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M189.61,114.27c-.18.24-1.55-.55-3.34-.34s-3,1.26-3.21,1.06.06-.5.58-1a4.58,4.58,0,0,1,2.54-1.12,4.42,4.42,0,0,1,2.69.54C189.47,113.79,189.7,114.16,189.61,114.27Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M173.34,120.42a1.67,1.67,0,0,1-1.41,1.86A1.61,1.61,0,0,1,170,121a1.67,1.67,0,0,1,1.41-1.86A1.59,1.59,0,0,1,173.34,120.42Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M172.07,116.62c-.18.24-1.55-.54-3.34-.33s-3,1.25-3.21,1,0-.5.58-1a4.55,4.55,0,0,1,2.54-1.11,4.42,4.42,0,0,1,2.69.53C171.93,116.14,172.16,116.51,172.07,116.62Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M180.08,129.14a12,12,0,0,1,2.85-.86c.45-.1.87-.24.91-.56a2.37,2.37,0,0,0-.46-1.32c-.55-1.06-1.14-2.16-1.75-3.32-2.44-4.74-4.27-8.65-4.08-8.75s2.33,3.66,4.78,8.4l1.69,3.35a2.63,2.63,0,0,1,.45,1.76,1.18,1.18,0,0,1-.68.76,3.31,3.31,0,0,1-.76.2A12.05,12.05,0,0,1,180.08,129.14Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M184.2,150.13a34.56,34.56,0,0,1-18.33-2.6s5.42,8.57,18.69,5.84Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M179.82,133.53a3.25,3.25,0,0,0-3-.86,3,3,0,0,0-1.91,1.32,1.89,1.89,0,0,0,.1,2.15,2.18,2.18,0,0,0,2.42.33,7.12,7.12,0,0,0,2.13-1.63,2.15,2.15,0,0,0,.45-.59.6.6,0,0,0-.08-.66",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175,131c.29,0,.52,1.89,2.34,3.08s3.86.73,3.91,1c0,.12-.42.43-1.29.56a5,5,0,0,1-3.25-.73,4.21,4.21,0,0,1-1.83-2.6C174.67,131.49,174.83,131,175,131Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M171.72,109.56c-.12.51-1.93.48-4,1s-3.7,1.27-4,.86c-.15-.19.1-.68.73-1.23a6.83,6.83,0,0,1,2.9-1.41,6.92,6.92,0,0,1,3.22,0C171.34,109,171.77,109.32,171.72,109.56Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M188.36,109.17c-.27.44-1.55.16-3,.31s-2.7.59-3,.19c-.15-.19,0-.62.51-1.06a4.4,4.4,0,0,1,4.89-.41C188.25,108.55,188.47,109,188.36,109.17Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M152.19,94.47c-2.55.83-5.43,7.78-4.68,10.36a7.91,7.91,0,0,0,5.74,5.1,14.89,14.89,0,0,0,7.93-.51c3.63-1.11,7.46-3.61,7.71-7.39a14.76,14.76,0,0,0,13.88,3.81c4.86-1.25,8.46-8.69,9.82-13.52Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.34,120.49c-.06,0,0-.66-.33-1.77a7.38,7.38,0,0,0-2.68-3.93,7.12,7.12,0,0,0-10.05,9.89,7.15,7.15,0,0,0,7,2.81,7.16,7.16,0,0,0,3-1.31,7.32,7.32,0,0,0,2.68-3.92c.3-1.12.27-1.77.33-1.77a1.43,1.43,0,0,1,0,.47,5.62,5.62,0,0,1-.16,1.35,7.43,7.43,0,0,1-5.82,5.61,7.6,7.6,0,0,1-4-.3,7.42,7.42,0,0,1-3.54-2.64,7.53,7.53,0,0,1,0-9,7.55,7.55,0,0,1,7.52-2.93,7.43,7.43,0,0,1,5.82,5.61,5.62,5.62,0,0,1,.16,1.35A1.43,1.43,0,0,1,177.34,120.49Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.74,117.17c-.06,0,0-.65-.33-1.77a7.26,7.26,0,0,0-2.68-3.92,7.16,7.16,0,0,0-6.76-1,7,7,0,0,0-3.29,2.48A7.12,7.12,0,0,0,186,123.85a7.22,7.22,0,0,0,9.44-4.91c.3-1.11.27-1.77.33-1.77a1.43,1.43,0,0,1,0,.47,5.62,5.62,0,0,1-.16,1.35,7.43,7.43,0,0,1-5.82,5.61,7.55,7.55,0,0,1-7.52-2.93,7.57,7.57,0,0,1,0-9,7.44,7.44,0,0,1,3.54-2.63,7.61,7.61,0,0,1,4-.31,7.43,7.43,0,0,1,5.82,5.61,5.62,5.62,0,0,1,.16,1.35A1.43,1.43,0,0,1,195.74,117.17Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.24,116.44c-.06,0-.07-.35.17-.83a2.72,2.72,0,0,1,3.65-1.14c.47.26.66.55.61.59s-.31-.11-.76-.25a2.94,2.94,0,0,0-1.75,0,3,3,0,0,0-1.44,1C176.44,116.18,176.32,116.46,176.24,116.44Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.39,122.23a9.45,9.45,0,0,1-2.83,1.22,9.16,9.16,0,0,1-3,.73,18.35,18.35,0,0,1,5.83-2Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M289.77,144.62a2.3,2.3,0,0,0,1.27-3.06l-8,2.4a31.18,31.18,0,0,0,6.41-3.49c2.17-1.78,1.09-3.32,1.09-3.32l-8.23,3.17-4.66,2.74L266,160.85s9.11,4.45,10.72,3.17c2.83-2.26,4.38-7.3,5-9.86a34.28,34.28,0,0,0,5.71-2,5.34,5.34,0,0,0,1.71-1.93l-6.34,1.21c.92-.27,6.8-2.28,7.26-3,.82-1.27.31-1.83.31-1.83l-8,1.24.82-.6S287.7,145.42,289.77,144.62Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M260.43,163.14l-26.81,24.55c-3.33-.77-44.15-25.17-44.15-25.17L183,193.92s41.78,19.21,53.28,16.88c1.88-.38,5-.62,6.9-3.11,9.2-11.82,28.71-41.07,28.71-41.07Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278.65,161.91l-4.84-2.33,3.49-6.34,2.74-5.79,4.25-7.89L277.82,142a5.05,5.05,0,0,0-2,1.49l-10.65,14.71L260.49,163,265,175.27l5.36-8.36,3.13-.73C276.67,165.45,278.65,161.91,278.65,161.91Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M270.87,152a40.14,40.14,0,0,1,6.94-2.72,6,6,0,0,1,2.4-.31,2.18,2.18,0,0,1,1.82,1.42,2.27,2.27,0,0,1-1.11,2.34,8.72,8.72,0,0,1-2.61.92,4.52,4.52,0,0,0-2.41,1.27,7.57,7.57,0,0,0-1,2.38,8.35,8.35,0,0,1-6.16,5.29",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M268.71,162.54s.42-.13,1.16-.42a8.62,8.62,0,0,0,2.79-1.82,8.29,8.29,0,0,0,1.41-1.81,11.07,11.07,0,0,0,1-2.46,4,4,0,0,1,.72-1.35,3.5,3.5,0,0,1,1.32-.92c1-.44,2.09-.54,3.05-.94a3,3,0,0,0,1.23-.86,1.91,1.91,0,0,0,.48-1.28,1.89,1.89,0,0,0-1.87-1.56,7.29,7.29,0,0,0-2.56.44c-.81.23-1.56.47-2.23.71-1.35.47-2.42.91-3.16,1.22a8.49,8.49,0,0,1-1.16.46,5,5,0,0,1,1.08-.63c.72-.36,1.78-.85,3.12-1.37.68-.26,1.42-.52,2.23-.77a7.71,7.71,0,0,1,2.72-.5,2.92,2.92,0,0,1,1.47.53,2,2,0,0,1,.82,1.45,2.84,2.84,0,0,1-2,2.59c-1.07.44-2.15.54-3.06.93a3.34,3.34,0,0,0-1.16.8,3.67,3.67,0,0,0-.65,1.2,11.74,11.74,0,0,1-1,2.51,8.17,8.17,0,0,1-1.52,1.85,8.07,8.07,0,0,1-2.95,1.75,6.65,6.65,0,0,1-.91.23C268.82,162.55,268.71,162.56,268.71,162.54Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.43,250.87h-55A140.6,140.6,0,0,0,118,271.72l78.32.32C197.88,269.52,186.43,250.87,186.43,250.87Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M202.68,200.91c-1.86-24.6-8-40.06-8-40.06l-9.52-2.93h0c-1.44,6.29-11.69,8.37-17.52,5.62l-6.17-3.23c-19.81-3-18.79-1.33-23.37,1.42-4,2.39-3.61,20.24-3.61,20.24s-9.87,46.5-9.33,53.95,6.28,15,6.28,15h55c5.54,0,7.12-12.51,6.73-17.05S203.29,209,202.68,200.91Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.5,216.39a4.06,4.06,0,0,0,.92.78,16.82,16.82,0,0,0,2.84,1.66,17.35,17.35,0,0,0,4.69,1.41,16.41,16.41,0,0,0,6-.26,19.78,19.78,0,0,0,9.33-5.42,21.24,21.24,0,0,0,2.14-2.49,3.9,3.9,0,0,0,.64-1c-.08-.06-1.08,1.34-3.07,3.22a20.59,20.59,0,0,1-9.17,5.14,16.7,16.7,0,0,1-10.39-1C151.91,217.38,150.56,216.3,150.5,216.39Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.15,212.32a16,16,0,0,1-5.65,10.8,13.27,13.27,0,0,1-11.76,2.56,11.38,11.38,0,0,1-8-8.73,33.86,33.86,0,0,0,8.77,3.06,17.22,17.22,0,0,0,16.93-8l-.45.47",
    transform: "translate(-28.49 -23.96)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M113.42,199.77l27.69,13s11.29-25,12.26-28.39,4-8.82.9-15.94-11.49-9.73-16.13-6.7C127.78,168.52,113.42,199.77,113.42,199.77Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M200.49,201.09c1.3,0,16.14,7.77,16.14,7.77l8.46-28c-12.63-8.42-23-18-30.37-20L198.6,184Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M113.42,199.77a2.58,2.58,0,0,1,.55.2l1.53.65,5.6,2.48,18.38,8.38,2.24,1-.35.13c3.2-6.59,6-12.48,8-16.73l2.32-5c.25-.55.45-1,.62-1.36a1.81,1.81,0,0,1,.25-.46,2.66,2.66,0,0,1-.16.5c-.11.32-.29.79-.53,1.4-.49,1.21-1.22,2.95-2.17,5.1-1.9,4.29-4.64,10.22-7.83,16.81l-.11.24-.24-.11-2.24-1-18.32-8.53-5.52-2.63-1.49-.75A2.08,2.08,0,0,1,113.42,199.77Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M198,178.1a14.52,14.52,0,0,1,.57,1.72c.37,1.2.86,2.8,1.46,4.73,1.2,4,3,9.59,3,16a33.87,33.87,0,0,1-1.48,8.91c-.77,2.67-1.66,5-2.42,7s-1.42,3.5-1.87,4.58a11.37,11.37,0,0,1-.75,1.66,1.65,1.65,0,0,1,.12-.46c.12-.35.26-.77.44-1.27.43-1.18,1-2.74,1.71-4.64s1.57-4.3,2.31-7a34.61,34.61,0,0,0,1.42-8.78c-.08-6.35-1.75-11.94-2.87-15.95-.56-2-1-3.64-1.29-4.77-.15-.57-.25-1-.31-1.31A1.31,1.31,0,0,1,198,178.1Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M174.54,172.52a18.29,18.29,0,0,0-5.47-10.74c-1.44-1.44-3.16-2.88-3.44-4.89-.36-2.61,1.9-5,1.53-7.66-.45-3.26-4.53-4.67-6-7.62-2-4,1.45-9.11-.65-13-1.26-2.35-4.28-3.61-4.88-6.2-.4-1.68,2.8-4.12,3.55-7.76,1.67-8.19,2.52-14.52-5.43-19.29L149.12,89c-5.2,2.54-9.57,8.25-9.66,14.22-.05,2.83,1.4,5.66.17,8.2-1.71,3.54-5.71,5.73-6.92,9.48-1.72,5.36,3,11.36,1,16.6-1.23,3.09-4.45,4.86-6.48,7.49a11.45,11.45,0,0,0,.73,14.34,14.43,14.43,0,0,0-5.43,16.14c.83,2.43,2.7,4.83,5.26,5,3.67.2,5.76-4,8.45-6.46a11.44,11.44,0,0,1,15.45.41c2.82,2.92,4,7.33,7.25,9.72s8.23,2,11.42-.6A12.63,12.63,0,0,0,174.54,172.52Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M124,177.46",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M138.4,211c-5.25,8.62-8.91,13.58-8.91,13.58l47,28.64L171,265.94l-61-25.11s-6-6.19-3.89-13.08l9.72-26.84Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.05,228.94c.11.15,2.34-1.72,5.63-2.92s6.19-1.27,6.18-1.46a15.3,15.3,0,0,0-11.81,4.38Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M213,261.93l-11.73-5.61-22.89-1.82-1.87-1.29L171,265.94s6,2.87,9.15,3.12l19.24-.58,10.06,1Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279,216.75l-66,.53c-2.14,0-4.19,1-4.51,3.15l-7.21,48.09h-34a2,2,0,0,0,0,4H275.86l7.42-50.76A4.33,4.33,0,0,0,279,216.75Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M279,216.75a3.41,3.41,0,0,1,1,.09,4.38,4.38,0,0,1,2.52,1.68,4.22,4.22,0,0,1,.81,2.1,11.94,11.94,0,0,1-.24,2.72c-.28,1.94-.59,4.18-.95,6.69-1.45,10.09-3.55,24.62-6.12,42.49l0,.17h-.18l-105.32.06H167.7a2.68,2.68,0,0,1-1.49-.28,2.25,2.25,0,0,1,0-3.93,2.7,2.7,0,0,1,1.49-.28h33.59l-.25.22c2.59-17.23,5-33.3,7.18-47.71a3.73,3.73,0,0,1,1.23-2.51,4.85,4.85,0,0,1,2.52-1.12,21.83,21.83,0,0,1,2.66-.09l2.59,0,9.94-.07,17.65-.11,25.14-.13h8.46c.39,0,.59,0,.59,0l-.59,0-1.74,0-6.72.1-25.14.28-17.65.17-9.94.1-2.59,0a20.11,20.11,0,0,0-2.59.1,4.49,4.49,0,0,0-2.3,1,3.28,3.28,0,0,0-1.08,2.25c-2.15,14.42-4.55,30.49-7.12,47.72l0,.22H167.7a2.32,2.32,0,0,0-1.23.21,1.72,1.72,0,0,0,0,3,2.28,2.28,0,0,0,1.24.22h2.84l105.32.06-.2.18c2.64-17.86,4.8-32.38,6.29-42.46.38-2.51.72-4.75,1-6.69a13.13,13.13,0,0,0,.27-2.67A4.33,4.33,0,0,0,280,216.9,6.51,6.51,0,0,0,279,216.75Z",
    transform: "translate(-28.49 -23.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 214.71,
    cy: 220.05,
    r: 4.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M204,272c.1,0,2.2-12.23,4.69-27.35s4.45-27.39,4.36-27.41-2.2,12.23-4.69,27.36S203.87,272,204,272Z",
    transform: "translate(-28.49 -23.96)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterGraphic);
export default __webpack_public_path__ + "static/media/register_graphic.d0a436237988ce615d9e0ff214d2e807.svg";
export { ForwardRef as ReactComponent };